export const paymentCategoriesMapping: Record<string, string> = {
  "Invoicing": "DESC_TMInkas",
  "AdvanceInvoicing": "DESC_TMZal",
  "Overpayments": "DESC_TMOdesl"
}